import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Actions, ofType } from "@ngrx/effects";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GET_IMAGES_FAILURE, GetImagesAction } from "./images.actions";
import { Image } from "./media.interface";
import { getImagesSelector } from "./media.reducer";
import { ImageAddComponent } from "./image-add/image-add.component";

@Component({
  selector: "app-media",
  templateUrl: "./media.component.html",
  styleUrls: ["./media.component.scss"],
  standalone: false,
})
export class MediaComponent implements OnInit, OnDestroy {
  images: Image[] | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private actions$: Actions,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetImagesAction());
    this.store
      .select(getImagesSelector)
      .pipe(takeUntil(this.destroy$))
      .subscribe((images: Image[] | null) => {
        if (images != null) {
          this.images = images;
        }
      });
    this.actions$
      .pipe(ofType(GET_IMAGES_FAILURE), takeUntil(this.destroy$))
      .subscribe(() => {
        this.images = [];
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showAddForm(): void {
    this.dialog.open(ImageAddComponent, {
      width: "600px",
      maxWidth: "92vw",
      maxHeight: "calc(100vh - 48px)",
      panelClass: "app-dialog-panel",
    });
  }
}
